import { CustomDateFilterComponent } from "./component";
import { doesFilterPass } from "./handler";

const CustomDateSetFilter = {
  doesFilterPass,
  component: CustomDateFilterComponent
};

export default CustomDateSetFilter;
